import React from 'react'
import { Box, Typography } from '@mui/material'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { advancedColors } from '../../theme'
import { PlannerRow } from './categories'
import { headerCellSx } from './gridSx'

type Props = {
  row: PlannerRow
  expanded: boolean
  onToggle: () => void
}

const PlanRowLabel = ({ row, expanded, onToggle }: Props) => (
  <Box component="th" sx={headerCellSx}>
    <Box
      role={row.expandable ? 'button' : undefined}
      tabIndex={row.expandable ? 0 : undefined}
      onClick={row.expandable ? onToggle : undefined}
      onKeyDown={row.expandable ? (event) => event.key === 'Enter' && onToggle() : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 0.5,
        px: 1,
        py: 0.5,
        pl: row.indented ? 4 : 1,
        cursor: row.expandable ? 'pointer' : 'default',
      }}
    >
      <Typography
        sx={{
          fontWeight: row.indented ? 400 : 600,
          color: row.indented ? advancedColors.inkMuted : advancedColors.ink,
        }}
      >
        {row.label}
      </Typography>
      {row.expandable && (
        <ExpandMoreRoundedIcon
          fontSize="small"
          sx={{
            color: advancedColors.inkMuted,
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 120ms',
          }}
        />
      )}
    </Box>
  </Box>
)

export default PlanRowLabel
